// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b
import React from 'react';
import './styles.scss';
import InputMask from 'react-input-mask';

export default function InputMaskDateTime(props) {
  const { setDateTime, dateTime } = props;
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const minAllowedYear = 1900;
  const handleInputChange = (e) => {
    const inputDate = e.target.value;
    let [val1, val2, val3] = inputDate.split('/');
    if (val1 && val1.length === 4 && (val1 > currentYear || val1 < minAllowedYear)) {
      val1 = currentYear;
    }
    if (val2 && val2.length === 2 && (val2 > 12 || val2 < 1)) {
      val2 = 12;
    }

    if (val3) {
      if (val3 > 31 || val3 < 1) {
        val3 = 31;
      } else if ([4, 6, 9, 11].includes(parseInt(val2)) && val3 > 30) {
        val3 = 30;
      } else if ([1, 3, 5, 7, 8, 10, 12].includes(parseInt(val2)) && val3 > 31) {
        val3 = 31;
      } else if ([2].includes(parseInt(val2)) && val3 > 28) {
        val3 = 28;
      }
    }

    const isDateFormat = `${val1}/${val2}/${val3}`;
    setDateTime(isDateFormat);
  };

  return (
    <div className="input-mask">
      <InputMask
        mask="9999/99/99"
        maskChar="_"
        formatChars={{ 9: '[0-9]', _: '[0-9 ]' }}
        placeholder="1990/01/01"
        value={dateTime}
        onChange={handleInputChange}
        inputMode="numeric"
      />
    </div>
  );
}
